export const CLASSES = {
  PANEL: {
    DESKTOP_ACTIVE: "panel__container active",
    DESKTOP_INACTIVE: "panel__container",
    MOBILE_ACTIVE: "panel__container-mobile active",
    MOBILE_INACTIVE: "panel__container-mobile"
  },
  CONTENT: {
    DESKTOP_ACTIVE: "content__container active",
    DESKTOP_INACTIVE: "content__container",
    MOBILE_ACTIVE: "content__container-mobile active",
    MOBILE_INACTIVE: "content__container-mobile"
  },
  OVERLAY: {
    ACTIVE: "overlay active",
    INACTIVE: "overlay"
  },
  ITEM: {
    ACTIVE: "menu__item active",
    ACTIVE_ALT: "menu__item active-alt",
    INACTIVE: "menu__item"
  }
};

export const CONTEXT_PANEL_OPTIONS = {
  TIMELINE: "timeline",
  TASK: "task"
};

export const DEFAULT_ICONS = [
  {
    icon: "mdi-timeline-clock-outline",
    class: "menu__item",
    name: "Línea de tiempo",
    key: "timeline",
    can: "timeLine"
  },
  {
    icon: "mdi-content-paste",
    class: "menu__item",
    name: "Tareas",
    key: "task",
    can: "task"
  },
  {
    icon: "mdi-file-multiple",
    class: "menu__item",
    name: "Documentos",
    key: "documents",
    can: "documents"
  }
];

export const EXTRA_ICONS = {
  NOTIFICATION: {
    icon: "mdi-message-badge",
    class: "menu__item",
    name: "Notificaciones",
    key: "notifications",
    can: ""
  },
  SERVICES: {
    icon: "mdi-information-outline",
    class: "menu__item",
    name: "Servicios",
    key: "services",
    can: ""
  },
  OPTIONS: {
    icon: "mdi-format-list-bulleted",
    class: "menu__item",
    name: "Opciones",
    key: "options",
    can: ""
  },
  SEARCH: {
    icon: "mdi-feature-search-outline",
    class: "menu__item",
    name: "Búsqueda contextual",
    key: "contextFilter",
    can: ""
  }
};

export const LABELS = {
  TIMELINE: "Línea de tiempo",
  TASK: "Tareas",
  MESSAGES: "Mensajes",
  INFORMATION: "Información"
};

export const METHOD_ROLE = {
  VIEWS: "VIEWS",
  ADMIN_ROLE: "adminRole",
  USER_TAG: "USERNAME",
  USER_ROLE: "normal-user"
};

export const URL_VIEW = "/dashboard/categories-stats";

export const TEXTS = {
  WELCOME: "Bienvenido",
  INTRO_TEXT: "Dar click para acceder al dashboard de operaciones",
  EACH_30_DYS: "/30d",
  SPACE_AROUND: "space-around",
  CENTER: "center",
  BACKGROUND_COLOR: "background-color:",
  COLOR: "color:",
  NOT_USERNAME: "Sin nombre de usuario",
  DATA_UNAVAILABLE: "data unavailable"
};

export const CLASS_LOCAL_NAMES = {
  GRID_ELEMENT: "grid-element ",
  COLUMN_ELEMENT: "column-element ",
  CARD_WIDTH: "card-width ",
  SERVICE_CARD: "service-card ",
  TEXT_CONTENT: "text-content ",
  TEXT_SPAN_USERS: "text-span-users ",
  NUMBER_STYLE: "number-style ",
  ROW_ELEMENT: "row-element"
};

export const CATEGORIES = {
  USERS: "users",
  MESSAGES: "messages"
};

export const ARROW_LABEL = {
  CLOSE: "Ocultar",
  OPEN: "Mostrar"
};

export const GO_TO_TOP = "Regresar al Inicio";

export const LIST_CARD_ID = "listFormTemplateElement";

export const TIMELINE_ID = "eventTimeLineElement";
